var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00012 9.29821C1.00012 8.72385 1.00012 8.43667 1.07415 8.17221C1.13972 7.93794 1.24749 7.7176 1.39215 7.52201C1.55546 7.30121 1.78214 7.1249 2.23551 6.77228L9.01782 1.49715C9.36914 1.2239 9.54481 1.08727 9.73878 1.03476C9.90993 0.988415 10.0903 0.988415 10.2615 1.03476C10.4554 1.08727 10.6311 1.2239 10.9824 1.49715L17.7647 6.77228C18.2181 7.1249 18.4448 7.30121 18.6081 7.52201C18.7528 7.7176 18.8605 7.93794 18.9261 8.17221C19.0001 8.43667 19.0001 8.72385 19.0001 9.29821V16.5331C19.0001 17.6532 19.0001 18.2133 18.7821 18.6411C18.5904 19.0174 18.2844 19.3234 17.9081 19.5152C17.4803 19.7331 16.9202 19.7331 15.8001 19.7331H4.20012C3.08002 19.7331 2.51996 19.7331 2.09214 19.5152C1.71582 19.3234 1.40986 19.0174 1.21811 18.6411C1.00012 18.2133 1.00012 17.6532 1.00012 16.5331V9.29821Z",
    stroke: "#000025",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeNew);
export default __webpack_public_path__ + "static/media/homeNew.19ac3b750e4186315a012ce8fac1ba1f.svg";
export { ForwardRef as ReactComponent };